import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  fetchApi,
  makeResetCache,
  notifyError,
  notifyResponse,
  RecordPicker,
  selectUser,
  UserState,
} from 'gossamer-front-end';
import { AllBookSingleEventRequest, BookingView, UserView } from 'cb-model';
import { Button, InputGroup } from 'react-bootstrap';
import { FieldType, getFilter } from 'gossamer-unified';

export interface BookMemberToEventButtonProps {
  eventId: string;
}

export const BookUserToEventButton: React.FC<BookMemberToEventButtonProps> = (props) => {
  const [userId, setUserId] = React.useState<string | null>(null);
  const user = useSelector((state: { user: UserState }) => selectUser(state));
  const dispatch = useDispatch();
  const resetCache = makeResetCache(dispatch);

  const handleClick = async () => {
    try {
      const payload: AllBookSingleEventRequest = {
        userId,
        eventId: parseInt(props.eventId),
      };
      const response = await fetchApi('POST', `/main/book-user-to-event`, payload);
      resetCache(BookingView.id);
      setUserId(null);
      notifyResponse(response);
    } catch (e) {
      notifyError(e, 'An error occurred while booking the user to the event');
    }
  };
  return (
    <InputGroup>
      <InputGroup.Text>Book a Member to this Event</InputGroup.Text>
      <RecordPicker
        editable={true}
        onItemSelected={setUserId}
        value={userId}
        field={{
          seq: 0,
          type: FieldType.Reference,
          label: 'User',
          refEntity: UserView,
        }}
        queryOptions={{
          where: {
            and: [getFilter('email', 'sw', '')],
          },
        }}
      />
      <Button size="sm" variant="primary" disabled={!userId} onClick={handleClick}>
        Book
      </Button>
    </InputGroup>
  );
};
